module.exports = __webpack_public_path__ + "static/media/intro.c29b3925.png";